import {SVGProps} from "react";

// Arrow from the V2 footer links and buttons (Figma "Icon / arrow", 78:923).
export const ArrowRightSvg = ({color = '#E4BD79', ...props}: SVGProps<SVGSVGElement>) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
        <path d="M3.75 9H14.25M10.5 12.75L14.25 9L10.5 5.25" stroke={color} strokeWidth="1.275" strokeLinecap="round"
              strokeLinejoin="round"/>
    </svg>
)
